// app/javascript/controllers/sidebar_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["toggle"]

    connect() {
        this.toggleTargets.forEach(toggle => {
            toggle.addEventListener("click", (e) => this.toggleDropdown(e))
        })
    }

    toggleDropdown(event) {
        const button = event.currentTarget
        const menuId = button.dataset.controls
        const expanded = button.dataset.expanded === "true"
        let autoclose = button.dataset.autoclose
        const windowWidth = window.innerWidth;
        const breakpoint = 768;

        switch (autoclose) {
            case "true":
                autoclose = true
                break
            case "false":
                autoclose = false
                break
            case "mobile":
                autoclose = windowWidth < breakpoint
                break;
            case "desktop":
                autoclose = windowWidth >= breakpoint
                break;
            default:
                autoclose = true
        }

        const hiddenClass = button.dataset.hiddenClass || "ice:hidden"
        const menu = document.getElementById(menuId)

        document.addEventListener("click", function handleClick(e) {
            function modifyBehavior(e, button) {
                const menuId = button.dataset.controls
                const menu = document.getElementById(menuId)
                if (!button.contains(e.target) && autoclose) {
                    // menu.classList.add(hiddenClass)
                    $(menu).addClass(hiddenClass)
                    // navigation-dropdown-container
                    return true;
                } else {
                    return false;
                }
            }

            if (modifyBehavior(e, button)) {
                document.removeEventListener("click", handleClick)
            }
        })

        if (!menu) return

        $(menu).toggleClass(hiddenClass)
        if ($(button).hasClass('navbar-toggle')){
            $("#navigation-dropdown-container").toggleClass('ice:max-md:h-screen')
            $("body").toggleClass('ice:max-md:overflow-hidden')
            $("#user-mobile-profile").toggleClass('ice:hidden ice:flex')
        }
        // menu.classList.toggle(hiddenClass)
        button.dataset.expanded = (!expanded).toString()
    }
}